import React from "react";
import axios from "axios";
import { t } from "../../localization/localization";

import { Row, Container, Col } from "react-bootstrap";
import { Pie } from "react-chartjs-2";

export default class DergiDagilimi extends React.Component {
  state = {
    data: [],
  };

  componentDidMount() {
    axios
      .get(`${window._env_.BASE_URL}/gcris-api/report/dergiDagilimi`)
      .then((res) => {
        this.setState({
          data: res.data.map((e) => {
            return { label: e.sjr_quartile, data: e.count };
          }),
        });
      });
  }

  render() {
    const urlSearchParams = new URLSearchParams(this.props.location.search);
    const locale = urlSearchParams.get("locale") ?? "tr";
    const paletteName = urlSearchParams.get("palette");
    return (
      <Container>
        <Row>
          <h4>{t(locale, "/home/dergiDagilimi/title")}</h4>
        </Row>
        <Row>
          <Pie
            data={{
              labels: this.state.data.map((e) => e.label),
              datasets: [
                {
                  label: t(locale, "/home/dergiDagilimi/title"),
                  data: this.state.data.map((e) => e.data),
                  backgroundColor: generateColors(
                    this.state.data.length,
                    paletteName
                  ),
                  hoverBackgroundColor: generateColors(
                    this.state.data.length,
                    paletteName
                  ),
                },
              ],
            }}
            width={440}
            height={290}
            options={{
              title: t(locale, "/home/dergiDagilimi/title"),
              maintainAspectRatio: false,
              plugins: {
                datalabels: {
                  color: "white",
                },
              },
            }}
          />
        </Row>
      </Container>
    );
  }
}

const PALETTE = {
  cold: ["#003f5c", "#58508d", "#bc5090", "#ff6361", "#ffa600"],
};

function generateColors(count, paletteName) {
  var palette;
  if (!PALETTE[paletteName]) {
    palette = PALETTE["cold"];
  } else {
    palette = PALETTE[paletteName];
  }
  var colors = [];
  for (var i = 0; i < count; i++) {
    colors.push(palette[i % palette.length]);
  }
  return colors;
}
